import React, { useState } from 'react';

import styles from './CollapsibleSection.module.scss';

// A card that is only its title bar until it is opened. With storageKey the
// browser remembers whether the user left it open.
function CollapsibleSection(props: CollapsibleSectionProps) {
    const [open, setOpen] = useState<boolean>(() => {
        if (props.storageKey == undefined) return false;
        try {
            return localStorage.getItem(props.storageKey) == "open";
        } catch {
            return false;
        }
    });

    function toggle() {
        const next = !open;
        setOpen(next);
        if (props.storageKey == undefined) return;
        try {
            localStorage.setItem(props.storageKey, next ? "open" : "closed");
        } catch {
            // Private mode or blocked storage: it just isn't remembered
        }
    }

    return (
        <section className={styles.section}>
            <button type="button" className={styles.header} aria-expanded={open} onClick={toggle}>
                {props.icon && <span className={styles.icon}>{props.icon}</span>}
                <span className={styles.title}>{props.title}</span>
                <span className={styles.chevron + (open ? " " + styles.open : "")} aria-hidden="true" />
            </button>
            {open && <div className={styles.body}>{props.children}</div>}
        </section>
    );
}

class CollapsibleSectionProps {
    title!: string;
    icon?: React.ReactNode;
    storageKey?: string;
    children?: React.ReactNode;
}

export default CollapsibleSection;
